module.exports = __webpack_public_path__ + "static/media/dashboard-scape-card-1-icon.7c9315c1.svg";